// extracted by mini-css-extract-plugin
export default {"form-wrapper":"zip-form_form-wrapper__9g3l+","form-container":"zip-form_form-container__g8Xpb","button":"zip-form_button__i+3ue"};